module.exports = __webpack_public_path__ + "img/1533146667.9c86a6cd.jpg";